export * from './Slider';